import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import { defaultLocale } from '../config/i18n'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: `/${defaultLocale}`
    },
    {
      path: '/:locale',
      name: 'DefaultMap',
      component: App
    },
    {
      path: '/:locale/:mapid',
      name: 'customMap',
      component: App
    }, 
    {
      path: '/cad-fribourg/:locale/:mapid',
      name: 'cadfrcustomMap',
      component: App
    },
    {
      path: '/:locale/:mapid/register',
      name: 'register',
      component: App
    },
    {
      path: '/:locale/:mapid/login',
      name: 'login',
      component: App
    },
    {
      path: '/:locale/:mapid/recover',
      name: 'recover',
      component: App
    },
    {
      path: '/:locale/:mapid/estimate',
      name: 'estimate',
      component: App
    }
  ]
})
